import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { themeAwareWidgetDecorator } from '../themeAwareWidgetDecorator'
import { GlobalStyles } from '../common/globalStyles'
import { AssetList } from './assetList'
import { getAssetTree } from '../common/apis'
import { LineConfig } from './lineConfig'
import { FACTORY_CONFIG_ID } from '../common/utils'

interface IProps {
    urlParams: [ConfigType, lineConfig, QueryParams]
}
interface IContextValue {
    assetType: 'factory' | 'product'
    setAssetTree: (data: CountryData[] | ProductData[]) => void
    assetTree: CountryData[] | ProductData[]
}
export const configsContext = React.createContext<IContextValue>(null)
export const AssetConfigs = themeAwareWidgetDecorator(function({ urlParams }: IProps): JSX.Element {
    const [assetTree, setAssetTree] = useState<CountryData[] | ProductData[]>([])
    const [assetType, setAssetType] = useState(urlParams[0])
    const [showLineConfigs, setShowLineConfigs] = useState(false)
    const queryParams = urlParams[2]

    useEffect(() => {
        getAssetTree(urlParams[0].split('-')[0] as AssetType).then(response => {
            setAssetTree(response)
            setAssetType(urlParams[0])
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [urlParams])

    useEffect(() => {
        if (urlParams[0] === FACTORY_CONFIG_ID) {
            setShowLineConfigs(checkIfUrlForLineConfigIsOk(assetTree as CountryData[], queryParams))
        } else {
            setShowLineConfigs(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assetTree, queryParams?.country, queryParams?.factory])

    const contextValue = { assetType: urlParams[0].split('-')[0] as 'factory' | 'product', setAssetTree, assetTree }

    return (
        <React.Fragment>
            <GlobalStyles />
            <StyledAssetConfigs>
                <configsContext.Provider value={contextValue}>
                    {showLineConfigs ? (
                        <LineConfig
                            country={queryParams?.country}
                            factory={queryParams?.factory.toString()}
                            line={queryParams?.line}
                        />
                    ) : (
                        <AssetList assetTree={assetType === urlParams[0] ? assetTree : []} />
                    )}
                </configsContext.Provider>
            </StyledAssetConfigs>
        </React.Fragment>
    )
})

const StyledAssetConfigs = styled.main``

function checkIfUrlForLineConfigIsOk(assetTree: CountryData[], queryParams: QueryParams): boolean {
    const countryObj = assetTree.filter(country => country.countryName === queryParams?.country)?.[0]
    const factoriesNames = countryObj?.factories?.map(factory => factory.factoryName.toLowerCase())
    const queryParamFactoryName = queryParams?.factory ? queryParams?.factory?.toString().toLowerCase() : ''

    return factoriesNames?.includes(queryParamFactoryName)
}
